import { render } from "./MassiveUserImportComponent.vue?vue&type=template&id=5523f770"
import script from "./MassiveUserImportComponent.vue?vue&type=script&lang=js"
export * from "./MassiveUserImportComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__